<template>
    <div class="afterService">
        <dataAnalysisTemplate
            :echoData="echoData"
            :showData="crowdPortrait"
            @save="save"
            :viewData="viewData"
        ></dataAnalysisTemplate>
    </div>
</template>

<script>
import dataAnalysisTemplate from './dataAnalysisTemplate';
import { getDataAnalysisInfo } from '../../../../utils/apis';

export default {
    name: 'afterService',
    components: {
        dataAnalysisTemplate,
    },
    data() {
        return {
            viewData: {},
            crowdPortrait: 'afterService',
            echoData: {},
        };
    },
    methods: {
        save(val) {
            this.$emit('save', 7, val);
        },
        async getDataAnalysisInfoFn() {
            let res = await getDataAnalysisInfo({
                type: 7,
            });
            this.echoData = res.data;
        },
    },
    mounted() {
        this.getDataAnalysisInfoFn();
    },
};
</script>

<style scoped>
.afterService {
    width: 100%;
    height: 100%;
}
</style>
